// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isPlainObject(value: any): value is Record<string, unknown> {
    return (
        typeof value === 'object' &&
        value !== null &&
        value.constructor === Object &&
        Object.getPrototypeOf(value) === Object.prototype
    );
}
